import router from "@/router"
import userStore from "@/stores/user"
import usePermissionStore from "@/stores/permission"
import NProgress from "nprogress"
import "nprogress/nprogress.css"
import useConfigStore from "@/stores/config"
import { ElMessage } from "element-plus"

function getLastQuery(data) {
    return Array.isArray(data) ? data.at(-1) : data
}

async function authLogin() {
    const user = userStore()
    const uri = new URL(window.location.href)
    const obj = {} as {
        [key: string]: string
    }
    uri.searchParams.forEach((value, key) => {
        obj[key] = value
    })
    const redirectUrl = obj['redirectUrl']
    if(redirectUrl){
        sessionStorage.setItem('redirectUrl', redirectUrl)
    }else{
        const referrer = document.referrer
        if(referrer && !sessionStorage.getItem('referrer')){
            sessionStorage.setItem('referrer', referrer)
        }
    }
    if (obj["AUTHORIZATION"]) {
        user.token = getLastQuery(obj["AUTHORIZATION"])
        user.tenantCode = getLastQuery(obj["TENANT-CODE"])
        user.tenantId = getLastQuery(obj["TENANT-ID"])
        window.localStorage.setItem("SOURCE-HOST", obj["SOURCE-HOST"])
    } else if (obj["TENANT-ID"]) {
        const tenant = {
            name: "",
            id: Number(getLastQuery(obj["TENANT-ID"])),
            code: getLastQuery(obj["TENANT-CODE"])as string
        }
        obj.grant_type = obj.grant_type || "password"
        await user.loginByUsername(obj, tenant)
    }
}

NProgress.configure({ showSpinner: false }) // 进度条


// 白名单路由
const whiteList: any[] = ["Login"]
router.beforeEach(async (to, from, next) => {

    NProgress.start()
    const user = userStore()
    const permissionStore = usePermissionStore()

    if(/http[s]?\:\/\//.test(to.path)) {
        if(/^\//.test(to.path)) {
            const path = to.path.replace('/', '')
            window.location.href = path
            return
        }
        window.location.href = to.path
    }

    // 静默登录
    await authLogin()

    // 清除登录所需参数，防止静默登录死循环
    const query = JSON.parse(JSON.stringify(to.query))
    delete query.AUTHORIZATION
    delete query["TENANT-CODE"]
    delete query["TENANT-ID"]

    // 判定有没有登录
    if (user && user.token) {
        // 基本信息如果没有就重新获取
        if (!user.sysUser?.userId) user.getUserBaseInfo()

        !permissionStore.routeLoaded && await permissionStore.getRouteTable()
        // 登录成功，跳转到首页
        if (to.name == "Login") {
            next({ path: "/" })
            NProgress.done()
        } else {
            const systemConfig = await useConfigStore().fetchSystemBusinessConfig()
            if (to.path !== '/' && systemConfig.work_map_uri_auth === 'Y' && !(await permissionStore.hasPermission(to))) {

                const child = permissionStore.getChildren(to.matched.at(-2))
                if (child?.length) {
                    next({ path: permissionStore.getRoutePath(child[0]) })
                } else {
                    console.log('没有权限', to)
                    ElMessage.error('没有权限')
                    next({ path: '/' })
                }
            }
            next()
        }
    } else {
        if (to.name == "Login") next()
        if (whiteList.indexOf(to.name) != -1) {
            next()
        } else {
            next({ path: "/login" })
            NProgress.done()
        }
    }
})

router.afterEach((payload) => {
    document.title = (payload.meta?.title as string) || process.env.VUE_APP_PROJECT_NAME
    NProgress.done()
})
